import React from 'react';
import ReactDOM from 'react-dom/client';
import { MotionConfig } from 'framer-motion';
import App from './App';
import './styles/globals.css';
import { registerAssetCacheWorker } from './services/assetCache';
import homeArena from './assets/backgrounds/home-arena.jpg';
import homeArenaFullscreen from './assets/backgrounds/home-arena-fullscreen.jpg';

// Initialize Telegram Mini App
const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

preloadCriticalImages();
registerAssetCacheWorker();

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <MotionConfig reducedMotion="user">
      <App />
    </MotionConfig>
  </React.StrictMode>,
);

function preloadCriticalImages(): void {
  if (typeof document === 'undefined') return;
  if (document.head.querySelector('link[data-elmental-preload="home-arena"]')) return;

  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.href = homeArena;
  link.setAttribute('imagesrcset', `${homeArena} 1x, ${homeArenaFullscreen} 2x`);
  link.setAttribute('fetchpriority', 'high');
  link.setAttribute('data-elmental-preload', 'home-arena');
  document.head.appendChild(link);
}
